'use client'

import { Button, Image } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { IMAGE_BASE_URL, DOCUMENTATION_URL } from '../constants'

const DocumentationSection = () => {
  const translate = useTranslate('business.pro_integrations.documentation')

  return (
    <section
      className="pro-integrations__documentation"
      data-testid="pro-integrations-documentation"
    >
      <div className="pro-integrations__documentation-inner">
        <div className="pro-integrations_documentation-content">
          <h2
            className="pro-integrations__documentation-title"
            data-testid="pro-integrations-documentation-title"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: translate('title') }}
          />
          <p
            className="pro-integrations__documentation-description"
            data-testid="pro-integrations-documentation-description"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: translate('description') }}
          />
          <div className="pro-integrations__documentation-button">
            <Button
              styling={Button.Styling.Outlined}
              text={translate('action')}
              url={DOCUMENTATION_URL}
              urlProps={{ target: '_blank' }}
              inverse
              testId="pro-integrations-documentation-description-button"
            />
          </div>
        </div>
        <div className="pro-integrations__documentation-image">
          <Image
            src={`${IMAGE_BASE_URL}/documentation-hero.png`}
            srcset={`${IMAGE_BASE_URL}/documentation-hero.png 200w, ${IMAGE_BASE_URL}/documentation-hero@2x.png 400w`}
            scaling={Image.Scaling.Cover}
            loading="lazy"
            testId="pro-integrations-documentation-image"
          />
        </div>
      </div>
    </section>
  )
}

export default DocumentationSection
